<div class="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true">
  <div class="absolute inset-0 bg-black/40" (click)="close()"></div>
  <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 mx-4">
    <h3 class="font-semibold text-gray-900 mb-1">Export leads to Excel</h3>
    <p class="text-sm text-gray-500 mb-4">
      <ng-container *ngIf="mode === 'custom'">{{ countValid ? (count | number) : '—' }} leads</ng-container>
      <ng-container *ngIf="mode === 'all'">All ~{{ (companiesLeft ?? config.total_companies) | number }} remaining companies' leads</ng-container>
      from <span class="font-medium text-gray-700">{{ config.summary_label }}</span>
      — delivered as an Excel file on the Exports page.
    </p>

    <!-- How many -->
    <div class="space-y-2 mb-4">
      <label class="flex items-center gap-2 text-sm text-gray-700">
        <input type="radio" name="export-mode" value="custom" class="text-violet-600 focus:ring-violet-500"
               [(ngModel)]="mode" [disabled]="isStarting">
        <span>Number of leads</span>
        <input type="number" min="11" [max]="maxLeads" step="1"
               class="w-28 rounded-lg border-gray-300 text-sm focus:ring-violet-500 focus:border-violet-500 disabled:bg-gray-100"
               [(ngModel)]="count" [disabled]="isStarting || mode !== 'custom'">
        <span class="text-xs text-gray-400">11–{{ maxLeads | number }}</span>
      </label>
      <label class="flex items-center gap-2 text-sm text-gray-700">
        <input type="radio" name="export-mode" value="all" class="text-violet-600 focus:ring-violet-500"
               [(ngModel)]="mode" [disabled]="isStarting">
        <span>All<span *ngIf="companiesLeft !== null"> (~{{ companiesLeft | number }} companies left)</span></span>
      </label>
    </div>

    <app-export-columns-picker [value]="columns" (valueChange)="onColumnsChange($event)" [disabled]="isStarting" [open]="true"></app-export-columns-picker>

    <label class="flex items-start gap-2 text-sm text-gray-700 mb-4" [class.opacity-60]="!emailColumn">
      <input type="checkbox" class="mt-0.5 rounded border-gray-300 text-violet-600 focus:ring-violet-500"
             [ngModel]="withEmails" (ngModelChange)="includeEmails = $event" [disabled]="isStarting || !emailColumn">
      <span *ngIf="emailColumn">Include emails — 2 credits per email found, nothing if not found</span>
      <span *ngIf="!emailColumn">Include emails — add the Email column to include emails</span>
    </label>

    <!-- Cost -->
    <div class="rounded-lg bg-gray-50 border border-gray-100 p-3 text-sm text-gray-700 space-y-1 mb-3">
      <div class="flex justify-between">
        <span>Leads</span>
        <span>up to <span class="font-semibold">{{ leadsCost | number }}</span> credits</span>
      </div>
      <div class="flex justify-between" *ngIf="withEmails">
        <span>Emails</span>
        <span>up to <span class="font-semibold">{{ emailsCost | number }}</span> credits</span>
      </div>
      <div class="flex justify-between text-gray-500" *ngIf="balance !== null">
        <span>Current balance</span>
        <span>{{ balance | number }} credits</span>
      </div>
    </div>

    <p class="text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded px-2 py-1.5 mb-3">
      Credits are charged as leads are generated. The export stops when your credits run out — you keep everything generated so far.
      <span *ngIf="shortOfCredits" class="block mt-1 font-medium">Your balance doesn't cover the maximum cost.</span>
    </p>

    <p *ngIf="errorMessage" class="text-sm text-red-600 mb-3">{{ errorMessage }}</p>

    <div class="flex justify-end gap-2">
      <button type="button"
              class="px-4 py-2 rounded-lg border border-gray-300 text-sm text-gray-600 hover:bg-gray-50 disabled:opacity-50"
              [disabled]="isStarting" (click)="close()">
        Cancel
      </button>
      <button type="button"
              class="px-4 py-2 rounded-lg bg-violet-600 text-white text-sm font-medium hover:bg-violet-700 disabled:opacity-50 inline-flex items-center gap-2"
              [disabled]="isStarting || (mode === 'custom' && !countValid)" (click)="start()">
        <span *ngIf="isStarting" class="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"></span>
        {{ isStarting ? 'Starting…' : 'Start export' }}
      </button>
    </div>
  </div>
</div>
